// MEE - Mobile Employee Experience app a.k.a. Viva Connections
const VivaConnectionsAppName = 'MEE App';

type IsVivaConnectionsApp = () => boolean;
export const isVivaConnectionsApp: IsVivaConnectionsApp = () =>
  typeof navigator !== 'undefined' && navigator.userAgent.includes(VivaConnectionsAppName);
